var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"visible":_vm.firewareBatchUpgradeDialogShow,"title":_vm.$t('meter.versionCheck')},on:{"update:visible":function($event){_vm.firewareBatchUpgradeDialogShow=$event}}},[_c('div',[_vm._v("firewareBatchUpgradeDialog")])])}
var staticRenderFns = []

export { render, staticRenderFns }